import script from "./AppNavigationGlobal.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNavigationGlobal.vue?vue&type=script&setup=true&lang=js"

import "./AppNavigationGlobal.vue?vue&type=style&index=0&id=770b1398&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770b1398"]])

export default __exports__